// @flow

export default class Characteristics {
  equipped: boolean;
  air_conditioner: boolean;
  heating: boolean;
  kitchen: boolean;
  universal_access: boolean;
  yard: boolean;
  universal_access: boolean;
  
  constructor(data: any = {}) {
    this.equipped = data.equipped;
    this.air_conditioner = data.air_conditioner;
    this.heating = data.heating;
    this.kitchen = data.kitchen;
    this.yard = data.yard;
    this.universal_access = data.universal_access;
  }
}
